module.exports = __webpack_public_path__ + "static/logo-444fabeaf46aaf7665c50f8ca95d9ec6.jpg";